import { Columns2 } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

export default function CompareDocumentLink({ kind, versionId, documentId, jobId, compact = false, className = '' }) {
  const location = useLocation();
  if (!versionId && !documentId && !jobId) return null;
  const query = new URLSearchParams({ from: location.pathname + location.search });
  if (versionId) query.set('version', versionId);
  if (documentId) query.set('document', documentId);
  if (jobId) query.set('job', jobId);
  const label = `Compare ${kind === 'resume' ? 'résumé' : 'cover letter'} with original`;
  return <Link to={`/document-comparison/${kind}?${query}`} aria-label={label} title={label}
    onClick={event => event.stopPropagation()} data-testid={`compare-${kind}-${versionId || documentId}`}
    className={`inline-flex shrink-0 items-center justify-center ${compact ? 'h-[18px] w-[18px]' : 'h-6 w-6'} rounded border border-border text-muted-foreground hover:text-primary hover:bg-primary/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ${className}`}>
    <Columns2 className={compact ? 'h-2.5 w-2.5' : 'h-3.5 w-3.5'} aria-hidden="true" />
  </Link>;
}
